import React from "react";
import ReactDOM from "react-dom";

import "./tools-tooltip.css";

import WComponent from "../../../common/WComponent";

const GAP_FROM_TRIGGER = 8;
const EDGE_MARGIN = 12;
const DEFAULT_MAX_WIDTH = 380;

class ToolsTooltip extends WComponent {
	constructor(props) {
		super(props);

		this.state = { isOpen: false, position: null };
		this.triggerRef = React.createRef();
	}

	componentWillUnmount() {
		this.detachListeners();
	}

	attachListeners = () => {
		window.addEventListener("resize", this.hide);
		window.addEventListener("scroll", this.hide, true);
	};

	detachListeners = () => {
		window.removeEventListener("resize", this.hide);
		window.removeEventListener("scroll", this.hide, true);
	};

	computePosition = () => {
		const triggerElement = this.triggerRef.current;
		if (!triggerElement) return null;

		const { maxWidth = DEFAULT_MAX_WIDTH } = this.props;
		const trigger = triggerElement.getBoundingClientRect();

		const widthAvailable = Math.min(maxWidth, window.innerWidth - EDGE_MARGIN * 2);
		const preferredLeft = trigger.left;
		const furthestLeft = window.innerWidth - widthAvailable - EDGE_MARGIN;
		const left = Math.max(EDGE_MARGIN, Math.min(preferredLeft, furthestLeft));

		const roomBelow = window.innerHeight - trigger.bottom;
		const showAbove = roomBelow < 120 && trigger.top > roomBelow;
		const top = showAbove ? undefined : trigger.bottom + GAP_FROM_TRIGGER;
		const bottom = showAbove ? window.innerHeight - trigger.top + GAP_FROM_TRIGGER : undefined;

		return { left, top, bottom, width: widthAvailable };
	};

	show = () => {
		if (!this.props.content) return;
		this.attachListeners();
		this.update({ isOpen: true, position: this.computePosition() });
	};

	hide = () => {
		this.detachListeners();
		this.update({ isOpen: false, position: null });
	};

	renderBubble = () => {
		const { content } = this.props;
		const { isOpen, position } = this.state;
		if (!isOpen || !position) return null;

		const bubble = (
			<div
				className="tools-tooltip__bubble"
				role="tooltip"
				style={{ left: position.left, top: position.top, bottom: position.bottom, maxWidth: position.width }}
			>
				{content}
			</div>
		);
		return ReactDOM.createPortal(bubble, document.body);
	};

	onTriggerClicked = event => {
		this.hide();
		if (this.props.onClick) this.props.onClick(event);
	};

	render() {
		const { children, className } = this.props;

		return (
			<span
				ref={this.triggerRef}
				className={className ? `tools-tooltip ${className}` : "tools-tooltip"}
				onMouseEnter={this.show}
				onMouseLeave={this.hide}
				onFocus={this.show}
				onBlur={this.hide}
				onClick={this.onTriggerClicked}
			>
				{children}
				{this.renderBubble()}
			</span>
		);
	}
}

export default ToolsTooltip;
